import { render, staticRenderFns } from "./QuestionTable.vue?vue&type=template&id=dd452510"
import script from "./QuestionTable.vue?vue&type=script&lang=js"
export * from "./QuestionTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports